import {Button, Card, CardBody, CardHeader, Typography,} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import {DiscountGrid} from "./grid";
import {DiscountForm} from "./form";
import {getDiscounts} from "../../../services/discount/discount";
import {CardFooterPaginator} from "../../system/cardFooterPaginator";
import {DiscountContext} from "../../../context/discount_context";


export function DiscountManagement() {

  const [discounts, setDiscounts] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [gridRowCount, setGridRowCount] = useState(10);
  const [gridCurrentPage, setGridCurrentPage] = useState(1);
  const [gridSelectedRow, setGridSelectedRow] = useState(null);
  const [gridTotalRowCount, setGridTotalRowCount] = useState(0);
  const [sortBy, setSortBy] = useState("id")
  const [sortType, setSortType] = useState(false);
  const [from, setFrom] = useState((gridCurrentPage - 1) * gridRowCount + 1);
  const [to, setTo] = useState((gridCurrentPage) * gridRowCount);
  const [lastDataRefresh, setLastDataRefresh] = useState(null);

  // const [fieldId, setFieldId] = useState(null);
  // const [branchId, setBranchId] = useState(null);
  // const [status, setStatus] = useState(null);
  // const [serviceType, setServiceType] = useState(null);
  // const [discountCode, setDiscountCode] = useState(null);
  // const [percentage, setPercentage] = useState(null);
  // const [expirationDate, setExpirationDate] = useState(null);


  useEffect(() => {
    if ((gridCurrentPage) * gridRowCount <= gridTotalRowCount) {
      setTo((gridCurrentPage) * gridRowCount)
    } else {
      setTo(gridTotalRowCount)
    }
    if (gridTotalRowCount === 0) {
      setFrom(0)
    } else {
      setFrom((gridCurrentPage - 1) * gridRowCount + 1)
    }
  }, [gridCurrentPage, gridRowCount, gridTotalRowCount]);

  async function getData(paginate) {
    const result = await getDiscounts(paginate);
    if (result.status === 200) {
      const {discountList, total_count} = result.data;
      setDiscounts(discountList || []);
      setGridTotalRowCount(total_count);
    }
  }

  useEffect(() => {
    const paginateParams = new URLSearchParams({
      "sort_by": sortBy,
      "sort_type": sortType === false ? "DESC" : "ASC",
      "limit": parseInt(gridRowCount),
      "offset": (parseInt(gridCurrentPage) - 1) * parseInt(gridRowCount),
    })

    const paginate = paginateParams.toString()

    getData(paginate)
  }, [lastDataRefresh, gridCurrentPage, gridRowCount, sortBy, sortType]);

  return (
    <DiscountContext.Provider value={{
      modalOpen,
      setModalOpen,
      gridRowCount,
      setGridRowCount,
      gridCurrentPage,
      setGridCurrentPage,
      discount: gridSelectedRow,
      setDiscount: setGridSelectedRow,
      discounts: discounts,
      setDiscounts: setDiscounts,
      lastDataRefresh,
      setLastDataRefresh,
      gridTotalRowCount,
      setGridTotalRowCount,
      sortBy,
      setSortBy,
      sortType,
      setSortType,
      from,
      setFrom,
      to,
    }}>
      <div className="">
        <DiscountForm/>
        <Card className="pt-8">
          <CardHeader floated={true} shadow={false} className="rounded-none">
            <div className="mb-8 flex items-center justify-between gap-8">
              <Typography variant="h5" color="blue-gray">تخفیف‌ها</Typography>
              <Button onClick={() => {
                setGridSelectedRow(null);
                setModalOpen(true);
              }} variant="outlined">جدید</Button>
            </div>
          </CardHeader>
          <CardBody className="overflow-x-auto w-full">

            <DiscountGrid
              Discounts={discounts}
              setSortBy={setSortBy}
              sortType={sortType}
              setSortType={setSortType}
              setSelectedRow={setDiscounts}
            />
          </CardBody>
          <CardFooterPaginator
            active={gridCurrentPage}
            setActive={setGridCurrentPage}
            totalRows={gridTotalRowCount}
            rowsCount={gridRowCount}
            setRowsCount={setGridRowCount}
            from={from}
            to={to}
          />
        </Card>
      </div>
    </DiscountContext.Provider>
  );
}